import React, { useContext, useEffect, useState } from 'react';
import {
  Alert, TextField,
} from '@mui/material';
import { SectionHeading } from '../SectionHeading';
import { FormDataContext } from '../../contexts/FormDataContext';

export const Email = ({errorMessage,isAccountExists}) => {
  const [inputFocused, setInputFocused] = useState(false);

  const {
    email,
    setEmail,
    currentUserEmail,
    intakeDataLoaded,
  } = useContext(FormDataContext);

  const handleEmailChange = event => {
    setInputFocused(false);
    setEmail(event.target.value);
  };

  const handleEnterPress = event => {
    if(event.keyCode === 13) {
      setEmail(event.target.value);
    }
  };

  const inputIsEmpty = () => {
    return !inputFocused && !email && !currentUserEmail;
  }

  return (
    <>
      <SectionHeading>
        Email Address
      </SectionHeading>
      {intakeDataLoaded &&
        <>
          <TextField
            sx={{marginTop: '10px'}}
            variant="outlined"
            label={inputIsEmpty() ? "Your email" : ''}
            placeholder="Your email *"
            type="email"
            defaultValue={currentUserEmail}
            onBlur={handleEmailChange}
            onKeyDown={handleEnterPress}
            onFocus={() => setInputFocused(true)}
            required={true}
            error={!!errorMessage}
            inputProps={!inputIsEmpty() ? {
              "aria-label": "Your email"
            } : {}}
            InputProps={{
              'aria-describedby': errorMessage ? 'email-message' : undefined
            }}
            InputLabelProps={{
              shrink: false
            }}
            fullWidth
            disabled={!!currentUserEmail}
            helperText="We recommend using a personal email account for optimal performance: .gov, .mil, & .edu domains can encounter issues with delivery."
          />
          {errorMessage &&
            <Alert sx={{marginY: '4px'}} id="email-message" severity="error">
              {errorMessage}
            </Alert>
          }
          {isAccountExists &&
            <Alert sx={{marginY: '4px'}} id="email-message" severity="success">
              An email containing a login link has been sent to your address.  Please click the link to complete your login.
            </Alert>
          }
        </>
      }
    </>
  );
};